import { createModule } from '../../createModule';
// import { allInstrumentsSchema } from './schemas'
export const createInstrumentsAPI = createModule(({ http }) => {
    return {
        listAll: async () => {
            const res = await http.get('/v2/instruments/list');
            return res;
        },
        updateInstrument: async (params) => {
            const res = await http.patch('/v2/instruments/instrument', { body: params });
            return res;
        },
        listAllBasketoptions: async (params) => {
            const res = await http.get('/v2/instruments/list/basketoptions', {
                params,
            });
            return res;
        },
        updateBasketoption: async (params) => {
            const res = await http.patch('/v2/instruments/basketoption', { body: params });
            return res;
        },
        listAllVanillaoptions: async (params) => {
            const res = await http.get('/v2/instruments/list/vanillaoptions', {
                params,
            });
            return res;
        },
        listAllBarrieroptions: async (params) => {
            const res = await http.get('/v2/instruments/list/barrieroptions', {
                params,
            });
            return res;
        },
        listAllMarketdataInstruments: async (params) => {
            const res = await http.get('/v2/instruments/list/marketdata-instruments', {
                params,
            });
            return res;
        },
        updateMarketdataInstrument: async (params) => {
            const res = await http.patch('/v2/instruments/marketdata-instrument', { body: params });
            return res;
        },
        inspectBooked: async (params) => {
            const res = await http.get(`/v2/instruments/inspect-booked/${params.id}`);
            return res;
        },
        getInstrumentsByType: (instrument_type_ids) => {
            return http.get(`/v2/instruments/map/instrument_types`, {
                params: { instrument_type_ids },
            });
        },
        getInstrumentTypes: () => {
            return http.get('/v2/static/map/instrument_types');
        },
        getInstrumentsByIds: (instrument_ids) => {
            return http.post('/v2/instruments/batch/lookup', {
                body: {
                    instrument_ids,
                },
            });
        },
        getInstrumentById: (instrument_id) => {
            return http.get(`/v2/instruments/${instrument_id}`);
        },
        getUnderlyingPrices: (params) => {
            return http.get(`/v2/instruments/underlyings/prices`, {
                params,
            });
        },
        getAutocallables: async () => {
            const res = await http.get('/v2/instruments/autocallables/unique_ids');
            return res;
        },
        create: async (body) => {
            // const parsed = parseInput(allInstrumentsSchema, body)
            return http.post(`/v2/instruments/create/${body.instrument_type}`, {
                body,
            });
        },
    };
});
